module.exports = __webpack_public_path__ + "img/3.1702eeda.png";